import { render, staticRenderFns } from "./fauduration.vue?vue&type=template&id=f8d6c766&scoped=true&"
import script from "./fauduration.vue?vue&type=script&lang=js&"
export * from "./fauduration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d6c766",
  null
  
)

export default component.exports